import {Helmet} from '@dr.pogodin/react-helmet';
import {Action, openDialog} from 'platform/components';

import {useMatch} from 'react-router-dom';

import i18n from '@dms/i18n';
import {importRoutes} from '@dms/routes';
import {DocumentExtractionImportDialog, Main, PageTab} from '@dms/shared';

import {buildArray} from 'shared/web';

import {ExtractedDeliveryNotes} from './components/ExtractedDeliveryNotes';
import {ImportDialog} from './components/ImportDialog';
import {Imports} from './components/Imports';

export function ImportsOverview() {
  const importsMatch = useMatch(importRoutes.overview);
  const extractedDeliveryNotesMatch = useMatch(importRoutes.extractedDeliveryNotes);

  const openImportDialog = () => {
    openDialog(<ImportDialog dialogId="import-dialog" />, {
      title: i18n.t('entity.import.actions.createImportTask'),
      id: 'import-dialog',
    });
  };

  const openImportDialogForDeliveryNote = () => {
    openDialog(
      <DocumentExtractionImportDialog
        dialogId="document-extraction"
        data-testid="document-extraction"
      />,
      {
        id: 'document-extraction',
      }
    );
  };

  const tabs = buildArray<PageTab>()
    .add({
      id: 'imports',
      title: i18n.t('entity.import.heading.title'),
      content: <Imports />,
      href: importRoutes.overview,
    })
    .add({
      id: 'extracted-delivery-notes',
      title: i18n.t('page.import.labels.extractedDeliveryNotes'),
      content: <ExtractedDeliveryNotes />,
      href: importRoutes.extractedDeliveryNotes,
    });

  const actions = buildArray<Action>()
    .when(importsMatch, {
      type: 'button',
      title: i18n.t('entity.import.actions.createImportTask'),
      onClick: openImportDialog,
    })
    .when(extractedDeliveryNotesMatch, {
      type: 'button',
      title: i18n.t('entity.import.actions.extractDeliveryNote'),
      onClick: openImportDialogForDeliveryNote,
    });

  return (
    <>
      <Helmet title={i18n.t('module.import.title')} />
      <Main isFullHeight tabs={tabs} actions={actions} />
    </>
  );
}
